import { Intent, Tag } from "@blueprintjs/core";
import { segmentTrackSidebarMenuItemClicked } from "analytics/analyticTrackEvents";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { DateTime } from "luxon";
import React, { useState } from "react";
import { getScopeFromScopes } from "types/scope";
import ScopeAssumptionsDialog from "./ScopeAssumptionsDialog";
import "./ScopeAssumptionsSection.scss";

const getSummary = (date?: DateTime, model?: string) => {
    const datePart =
        date === undefined ? (
            "Scope assumptions"
        ) : (
            <>
                Data as of <strong>{date.toLocaleString()}</strong>
            </>
        );
    return (
        <>
            {datePart}
            {model !== undefined && ` • ${model}`}
        </>
    );
};

const ScopeAssumptionsSection: React.FC = () => {
    const {
        busFiltersConfiguration: {
            busFilters: { scope }
        }
    } = useMapViewConfiguration();
    const { scopes } = useUserDataContext();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const currentScope = getScopeFromScopes(scopes, scope);
    if (currentScope === undefined) {
        return null;
    }

    return (
        <div className="ScopeAssumptionsSection-wrapper">
            <span className="ScopeAssumptionsSection-summary">
                {getSummary(
                    currentScope.data_freshness_date,
                    currentScope.data_freshness_model
                )}
            </span>
            <Tag
                intent={Intent.PRIMARY}
                interactive
                minimal
                round
                onClick={() => {
                    segmentTrackSidebarMenuItemClicked("DATA_FRESHNESS");
                    setIsDialogOpen(true);
                }}
            >
                <strong>Details</strong>
            </Tag>
            <ScopeAssumptionsDialog
                isOpen={isDialogOpen}
                closeDialog={() => setIsDialogOpen(false)}
                currentScope={currentScope}
            />
        </div>
    );
};

export default ScopeAssumptionsSection;
